@if (showFavouriteToggle) {
    <div class="toggle-favourite">
        <ms-favourite-league-toggle [id]="league.id" [name]="league.name" [sport]="sportId" [tracking]="{ source: 'Event List' }" />
    </div>
}

@if (useColoredIcon && hideFavourites && !isTournament) {
    <div class="colored-icon">
        <ms-colored-icon [iconClass]="iconClass" />
    </div>
}

@if (showCompetitionLogo) {
    <ms-competition-logo
        class="competition-logo"
        [sportId]="sportId"
        [leagueId]="league.id"
        [fallbackIcon]="fallbackIcon"
        [imageProfile]="league.imageProfile" />
}

<div class="title">
    <span>{{ title }}</span>
</div>
